import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoDeclaracionCeseTRADE = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoDeclaracionCeseTRADE = () => {
  const [loadingGetInfoDeclaracionCeseTRADE, setLoadingGetInfoDeclaracionCeseTRADE] = useState(false);
  const [successGetInfoDeclaracionCeseTRADE, setSuccessGetInfoDeclaracionCeseTRADE] = useState(false);
  const [errorGetInfoDeclaracionCeseTRADE, setErrorGetInfoDeclaracionCeseTRADE] = useState<any>(null);
  const [dataGetInfoDeclaracionCeseTRADE, setDataGetInfoDeclaracionCeseTRADE] = useState<any>(null);

  const [statusGetInfoDeclaracionCeseTRADE, setStatusGetInfoDeclaracionCeseTRADE] =
    useState<StatusGetInfoDeclaracionCeseTRADE>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoDeclaracionCeseTRADE = async (
    userId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoDeclaracionCeseTRADE(true);
    setSuccessGetInfoDeclaracionCeseTRADE(false);
    setErrorGetInfoDeclaracionCeseTRADE(null);

    try {
      const res = await apiRecord.getInfoSolicitudDeclaracionJuradaTrade(userId);

      setStatusGetInfoDeclaracionCeseTRADE({
        status: res.status,
        statusText: res.statusText
      });

      setDataGetInfoDeclaracionCeseTRADE(res.data);
      setSuccessGetInfoDeclaracionCeseTRADE(true);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetInfoDeclaracionCeseTRADE({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetInfoDeclaracionCeseTRADE(err);
      console.error("Error en getInfoDeclaracionCeseTRADE:", err);

      throw err;

    } finally {
      setLoadingGetInfoDeclaracionCeseTRADE(false);
    }
  };

  return {
    getInfoDeclaracionCeseTRADE,
    loadingGetInfoDeclaracionCeseTRADE,
    successGetInfoDeclaracionCeseTRADE,
    errorGetInfoDeclaracionCeseTRADE,
    dataGetInfoDeclaracionCeseTRADE,
    statusGetInfoDeclaracionCeseTRADE
  };
};

export default useGetInfoDeclaracionCeseTRADE;